<template>
  <div>
    <mt-header title="预约成功">
      <router-link to="/" slot="left">返回</router-link>
    </mt-header>

    <div class="exper-wrap">
      <div class="exper-head">
        <p class="head-title">
          您已成功预约,验证码
          <span class="code">{{ pass_key }}</span>
        </p>
        <p class="head-body">
          系统已自动帮您安排好(设备)座位，请根据以下信息按时体验，谢谢合作。VR设备和直播间预约后请直接向图书馆馆员出示预约证明。
        </p>
      </div>

      <appoint-info v-if="dataObj" :dataObj="dataObj"></appoint-info>
      <div class="exper-info">
        <div class="exper-title">
          <div class="act-point"></div>
          <p>体验须知</p>
        </div>
        <div class="exper-tips">
          <p>
            1、为避免您和他人产生误会，
            <span class="p-red">请截图保存本要页面</span>
          </p>
          <p>
            2、请提前到体验区等待，您的体验设备会根据您的预约时间锁屏，并显示设备序号，请按照序号解锁使用
          </p>
          <p>3、若您想延长使用时间，请进入“我的预约”进行预约</p>
          <p>
            4、若有其他读者已预约导致您无法续约，请遵照预约规则礼让下一位读者体验，您可以在平台上重新预约其他设备
          </p>
          <p class="p-red">5、您将遵守《读者公约》，对馆内所有设备不会进行恶意破坏从而影响其它读者使用，包含但不限于：恶意拔掉电源、退出程序、卸载程序、强制设备关机、物理破坏设备、随意挪动设备等。</p>
        </div>
      </div>
      <div class="exper-btn-wrap">
        <div @click="back" class="btn-suc">
          <p>我已经了解，并愿意遵守</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { myorderdetail } from "@/api/api";
import {
  formatDate,
  formatStartTimeTips,
  formatEndTimeTips,
  allTime,
} from "@/utils/util";
import appointInfo from "@/components/appointInfo";
export default {
  data() {
    return {
      logId: this.$route.query.logId,
      pass_key: this.$route.query.pass_key,
      dataObj: "",
    };
  },
  components: {
    appointInfo,
  },
  mounted() {
    myorderdetail({
      log_id: this.logId,
    }).then((res) => {
      this.dataObj = res;
      this.dataObj["date"] = formatDate(this.dataObj.day);
      this.dataObj["startTime"] = formatStartTimeTips(this.dataObj.start_time);
      this.dataObj["endTime"] = formatEndTimeTips(this.dataObj.end_time);
      this.dataObj["allTime"] = allTime(
        this.dataObj.start_time,
        this.dataObj.end_time
      );
    });
  },
  methods: {
    back() {
      this.$router.replace("/mine");
    },
  },
};
</script>
<style lang="less" scope>
.exper-wrap {
  padding: 20px;
  .exper-head {
    width: 100%;
    height: 20vh;
    .head-title {
      font-size: 0.5rem;
      font-weight: 700;
      padding: 16px 0;
      .code {
        font-size: 1rem;
        color: red;
      }
    }
    .head-body {
      font-size: 0.35rem;
      text-indent: 0.7rem;
      line-height: 0.6rem;
    }
  }
  .exper-body {
    width: 100%;
    padding: 20px;
    background-color: #006feb;
    border-radius: 10px;
    .body-item {
      width: 100%;
      height: 60px;
      display: flex;
      font-size: 0.35rem;
      color: #fff;
      justify-content: space-between;
    }
  }
  .exper-info {
    margin-top: 40px;
    .exper-title {
      font-size: 0.4rem;
      font-weight: 700;
      display: flex;
      align-items: center;
      .act-point {
        width: 6px;
        height: 22px;
        background-color: #006feb;
        margin-right: 10px;
      }
    }
    .exper-tips {
      margin-top: 20px;
      line-height: 0.7rem;
      font-size: 0.35rem;
    }
  }

  .exper-btn-wrap {
    width: 100%;
    margin-top: 20px;
    display: flex;
    justify-content: center;
    .btn-suc {
      width: 60vw;
      height: 6vh;
      background-color: #006feb;
      display: flex;
      color: #fff;
      font-size: 0.35rem;
      border-radius: 1rem;
      justify-content: center;
      align-items: center;
    }
  }
}

.p-red {
  color: red;
}
</style>